import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useTranslation } from '../useTranslation';

const Restaurant = () => {
  const { t } = useTranslation();
  const [plat, setPlats] = useState([]);
  const [specialites, setSpecialites] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('*');
  const category = "restaurant";
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8); 

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    number_of_people: 1,
    message: "",
  });
  const [bookingLoading, setBookingLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const specialitesCategories = ['Traditional', 'Seafood', 'Salads', 'Meat', 'Pastry'];
  
  const platsCategories = ['Plats principaux', 'Entrées', 'Desserts'];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: platData, error: platError } = await supabase
          .from('plat')
          .select('*')
          .order('created_at', { ascending: false });

        if (platError) throw platError;
        
        const platsNormaux = platData.filter(item => 
          !specialitesCategories.includes(item.category)
        );
        
        const platsSpeciaux = platData.filter(item => 
          specialitesCategories.includes(item.category)
        );
        
        setPlats(platsNormaux);
        setSpecialites(platsSpeciaux);

        const { data: imageData, error: imageError } = await supabase
          .from("category_images")
          .select("id, url, category")
          .eq("category", category);

        if (imageError) throw imageError;
        setImages(imageData);
      } catch (err) {
        console.error("Erreur de chargement:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredPlats = activeFilter === '*' 
    ? plat 
    : plat.filter(item => item.category === activeFilter.replace('filter-', ''));

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPlats = filteredPlats.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPlats.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [activeFilter]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🟡 Début de la soumission");
    
    setBookingLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const { error } = await supabase.from("booking").insert([{
        ...formData,
        number_of_people: parseInt(formData.number_of_people)
      }]);

      console.log("🟡 Réponse Supabase:", error);

      if (error) throw error;
      
      console.log("🟡 Définition du succès");
      setSuccess(`✅ ${t('bookingSuccess')}`);
      
      setFormData({
        name: "",
        email: "",
        phone: "",
        date: "",
        time: "",
        number_of_people: 1,
        message: "",
      });

      setTimeout(() => {
        setSuccess(null);
      }, 5000);

    } catch (err) {
      console.error("🔴 Erreur:", err);
      setError(err.message);
    } finally {
      setBookingLoading(false);
    }
  };

  console.log("📊 État:", { bookingLoading, error, success });

  const specialitesParCategorie = {
    'Traditional': specialites.find(item => item.category === 'Traditional'),
    'Seafood': specialites.find(item => item.category === 'Seafood'),
    'Salads': specialites.find(item => item.category === 'Salads'),
    'Meat': specialites.find(item => item.category === 'Meat'),
    'Pastry': specialites.find(item => item.category === 'Pastry')
  };

  return (
    <>
      <style>{`
        body {
          background: #0c0b09;
        }
        
        .specials {
          margin: 40px 0 -100px 0 !important;
        }
        
        .book-a-table {
          padding: 20px 0 40px 0 !important;
        }
        
        .booking-messages {
          min-height: 0;
          margin: 15px 0;
          transition: all 0.3s ease;
        }
        
        .booking-messages:empty {
          min-height: 0;
          margin: 0;
        }
        
        .booking-error {
          background: #f8d7da;
          color: #721c24;
          padding: 15px;
          border-radius: 8px;
          border: 1px solid #f5c6cb;
          margin: 10px 0;
          text-align: center;
          font-weight: 500;
        }
        
        .booking-success {
          background: #d4edda;
          color: #155724;
          padding: 15px;
          border-radius: 8px;
          border: 1px solid #c3e6cb;
          margin: 10px 0;
          text-align: center;
          font-weight: 500;
          animation: fadeIn 0.5s ease-in;
        }
        
        @keyframes fadeIn {
          from { 
            opacity: 0; 
            transform: translateY(-10px); 
            max-height: 0;
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
            max-height: 200px;
          }
        }
        
        .php-email-form .text-center {
          margin-top: 20px;
        }
        
        section:not(:target) {
          pointer-events: auto !important;
        }
        
        .specials .tab-content {
          min-height: 400px;
        }
        
        .booking-messages > div {
          display: block !important;
        }
        
        #book-a-table {
          position: relative;
          z-index: 1;
        }

        .special-price {
          color: #cda45e;
          font-weight: bold;
          font-size: 1.2em;
          margin: 10px 0;
        }

        .special-description {
          color: #fff;
          line-height: 1.6;
          margin-top: 15px;
        }
           .pagination .page-item.active .page-link {
        background-color: #4b4f5e;
        border-color: #4b4f5e;
        color: white;
      }
      
      .pagination .page-link {
        color: #6c7293;
        background-color: #191c24;
        border: 1px solid #2a2d3a;
      }
      
      .pagination .page-link:hover {
        background-color: #2a2d3a;
        border-color: #2a2d3a;
        color: white;
      }
      
      .pagination .page-item.disabled .page-link {
        background-color: #191c24;
        border-color: #2a2d3a;
        color: #6c7293;
      }
      `}</style>

      <section id="menu" className="menu section-bg" >
        <div className="container" data-aos="fade-up" style={{ marginBottom: '-30px' }}>
          <div className="section-title">
            <h2>{t('menuTitle')}</h2>
            <p>{t('menuSubtitle')}</p>
          </div>

          <div className="row" data-aos="fade-up" data-aos-delay="100">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="menu-flters">
                {['*', 'Entrées', 'Plats principaux', 'Desserts'].map((filter) => (
                  <li
                    key={filter}
                    className={activeFilter === `filter-${filter}` || (filter === '*' && activeFilter === '*') ? 'filter-active' : ''}
                    onClick={() => setActiveFilter(filter === '*' ? '*' : `filter-${filter}`)}
                  >
                    {filter === '*' ? 'All' : filter.charAt(0).toUpperCase() + filter.slice(1)}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="row" data-aos="fade-up" data-aos-delay="200">
            {currentPlats.length > 0 ? (
              currentPlats.map((item) => (
                <div
                  key={item.id}
                  className={`col-lg-6 menu-item ${item.category ? `filter-${item.category}` : ''}`}>
                  <img
                    src={item.image_url || "assets/img/menu/default.jpg"}
                    className="menu-img"
                    alt={item.name}
                    style={{ 
                      width: "70px", 
                      height: "70px", 
                      objectFit: "cover", 
                      borderRadius: "50%" 
                    }}
                  />
                  <div className="menu-content">
                    <a href="#">{item.name}</a>
                    <span>{item.price} DT</span>
                  </div>
                  <div className="menu-ingredients">{item.description}</div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
               <p>{t('noDishes')}</p>
              </div>
            )}
          </div>

          {filteredPlats.length > itemsPerPage && (
            <nav aria-label="Page navigation" className="mt-4" style={{ paddingTop: '30px' }}>
              <ul className="pagination justify-content-center">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={goToPreviousPage} aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                  </button>
                </li>
                
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => paginate(page)}>
                      {page}
                    </button>
                  </li>
                ))}
                
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={goToNextPage} aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </section>

      <section id="specials" className="specials" >
        <div className="container">
          <div className="section-title">
            <h2>{t('specialsTitle')}</h2>
            <p>{t('specialsSubtitle')}</p>
          </div>
          <div className="row">
            <div className="col-lg-3">
              <ul className="nav nav-tabs flex-column">
                {specialitesCategories.map((categorie, index) => (
                  <li className="nav-item" key={categorie}>
                    <a 
                      className={`nav-link ${index === 0 ? 'active show' : ''}`}
                      data-bs-toggle="tab" 
                      href={`#tab-${categorie}`}
                      onClick={(e) => {
                        e.preventDefault();
                        const tabPanes = document.querySelectorAll('.tab-pane');
                        const navLinks = document.querySelectorAll('.nav-link');
                        
                        navLinks.forEach(link => link.classList.remove('active', 'show'));
                        tabPanes.forEach(pane => pane.classList.remove('active', 'show'));
                        
                        e.target.classList.add('active', 'show');
                        document.getElementById(`tab-${categorie}`).classList.add('active', 'show');
                      }}
                    >
                      {categorie}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-9 mt-4 mt-lg-0">
              <div className="tab-content">
                {specialitesCategories.map((categorie, index) => {
                  const special = specialitesParCategorie[categorie];
                  
                  return (
                    <div 
                      className={`tab-pane ${index === 0 ? 'active show' : ''}`} 
                      id={`tab-${categorie}`} 
                      key={categorie}
                    >
                      {special ? (
                        <div className="row">
                          <div className="col-lg-8 details order-2 order-lg-1">
                            <h3>{special.name}</h3>
                            <p className="fst-italic">
                              {t(`special${index + 1}Desc`)}
                            </p>
                            <p className="special-description">
                              {special.description}
                            </p>
                            <div className="special-price">
                              {special.price} DT
                            </div>
                          </div>
                          <div className="col-lg-4 menu text-center order-1 order-lg-2">
                            <img
                              src={special.image_url || `assets/img/plat-${index + 1}.jpg`}
                              className="menu-img"
                              alt={special.name}
                              style={{ 
                                width: "260px", 
                                height: "260px", 
                                objectFit: "cover", 
                                borderRadius: "50%" 
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-lg-8 details order-2 order-lg-1">
                            <h3>
                              {index === 0 && t('special1Title')}
                              {index === 1 && t('special2Title')}
                              {index === 2 && t('special3Title')}
                              {index === 3 && t('special4Title')}
                              {index === 4 && t('special5Title')}
                            </h3>
                            <p className="fst-italic">
                              {index === 0 && t('special1Desc')}
                              {index === 1 && t('special2Desc')}
                              {index === 2 && t('special3Desc')}
                              {index === 3 && t('special4Desc')}
                              {index === 4 && t('special5Desc')}
                            </p>
                            <p>
                              {index === 0 && t('special1Detail')}
                              {index === 1 && t('special2Detail')}
                              {index === 2 && t('special3Detail')}
                              {index === 3 && t('special4Detail')}
                              {index === 4 && t('special5Detail')}
                            </p>
                            <p>
                              {t('notAvailable')}
                            </p>
                          </div>
                          <div className="col-lg-4 menu text-center order-1 order-lg-2">
                            <img
                              src={`assets/img/plat-${index + 1}.jpg`} 
                              className="menu-img"
                              alt=""
                              style={{ 
                                width: "260px", 
                                height: "260px", 
                                objectFit: "cover", 
                                borderRadius: "50%" 
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Réservation */}
      <section id="book-a-table" className="book-a-table">
        <div className="container">
          <div className="section-title">
            <h2>Reservation</h2>
            <p>{t('BookaTable')}</p>
          </div>

          <form onSubmit={handleSubmit} className="php-email-form">
            <div className="row">
              <div className="col-lg-4 col-md-6 form-group">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder={t('namePlaceholder')}
                  value={formData.name}
                  onChange={handleChange}
                  required />
              </div>
              <div className="col-lg-4 col-md-6 form-group mt-3 mt-md-0">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder={t('emailPlaceholder')} 
                  value={formData.email}
                  onChange={handleChange}
                  required />
              </div>
              <div className="col-lg-4 col-md-6 form-group mt-3 mt-md-0">
                <input
                  type="text"
                  name="phone"
                  className="form-control"
                  placeholder={t('phonePlaceholder')}
                  value={formData.phone}
                  onChange={handleChange}
                  required />
              </div>
              <div className="col-lg-4 col-md-6 form-group mt-3">
                <input
                  type="date"
                  name="date"
                  className="form-control"
                  value={formData.date}
                  onChange={handleChange}
                  required />
              </div>
              <div className="col-lg-4 col-md-6 form-group mt-3">
                <input
                  type="time"
                  name="time"
                  className="form-control"
                  value={formData.time}
                  onChange={handleChange}
                  required/>
              </div>
              <div className="col-lg-4 col-md-6 form-group mt-3">
                <input
                  type="number"
                  name="number_of_people"
                  className="form-control"
                  min="1"
                  value={formData.number_of_people}
                  onChange={handleChange}
                  required />
              </div>
            </div>
            <div className="form-group mt-3">
              <textarea
                className="form-control"
                name="message"
                rows="5"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            
            <div className="booking-messages">
              
              {error && (
                <div className="booking-error">
                  ❌ {error}
                </div>
              )}
              
              {success && (
                <div className="booking-success">
                  ✅ {success}
                </div>
              )}
            </div>
            
            <div className="text-center">
              <button type="submit" disabled={bookingLoading}>
                {bookingLoading ? t('Sending') : t('BookaTable2')}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Section Chefs */}
      <section id="chefs" className="chefs">
        <div className="container">
          <div className="section-title">
            <h2>{t('chefsTitle')}</h2>
            <p>{t('chefsSubtitle')}</p>
          </div>

          <div className="row">
            {[
              { id: 1, name: "Walter White", role: "Master Chef", delay: 100 },
              { id: 2, name: "Sarah Jhonson", role: "Patissier", delay: 200 },
              { id: 3, name: "William Anderson", role: "Cook", delay: 300 }
            ].map((chef) => (
              <div className="col-lg-4 col-md-6" key={chef.id}>
                <div className="member">
                  <img
                    src={`assets/img/chefs/chefs-${chef.id}.jpg`}
                    className="img-fluid"
                    alt={chef.name}
                    style={{
                      width: '100%',
                      height: '400px',
                      objectFit: 'cover'
                    }}
                  />
                  <div className="member-info">
                    <div className="member-info-content">
                      <h4>{chef.name}</h4>
                      <span>{chef.role}</span>
                    </div>
                    <div className="social">
                      <a href="/"><i className="bi bi-twitter"></i></a>
                      <a href="/"><i className="bi bi-facebook"></i></a>
                      <a href="/"><i className="bi bi-instagram"></i></a>
                      <a href="/"><i className="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Galerie */}
      <section id="gallery" className="gallery">
        <div className="container">
          <div className="section-title">
            <h2>{t('galleryTitle')}</h2>
          <p>{t('gallerySubtitle')}</p>
          </div>
        </div>

        <div className="container-fluid">
          {loading ? (
            <p className="text-center">Loading images...</p>
          ) : images.length === 0 ? (
            <p className="text-center">{t('noRestaurantImages')}</p>
          ) : (
            <div className="row g-0">
              {images.map((image) => (
                <div className="col-lg-3 col-md-4" key={image.id}>
                  <div className="gallery-item">
                    <a href={image.url} className="gallery-lightbox" data-gall="gallery-item">
                      <img
                        src={image.url}
                        alt={`Restaurant ${category}`}
                        className="img-fluid"
                        style={{
                          width: '100%',
                          height: '250px',
                          objectFit: 'cover'
                        }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Restaurant;